export default defineNuxtPlugin({
    name: 'forms',
    dependsOn: [],
    async setup(nuxtApp)
    {
        const app = nuxtApp.vueApp;
        app.provide('ol-options', { debug: false });
        const { components, filters, presenters } = await import('../components/forms/definitions');

        components.forEach((component: any) =>
        {
            app.component(`${component.key}-blueprint`.pascalCase(), defineAsyncComponent(component.value));
        });

        filters.forEach((component: any) =>
        {
            app.component(`${component.key}-filter`.pascalCase(), defineAsyncComponent(component.value));
        });

        presenters.forEach((component: any) =>
        {
            app.component(`${component.key}-presenter`.pascalCase(), defineAsyncComponent(component.value));
        });
    }
});
